module.exports = __webpack_public_path__ + "img/data.31b3cbd6.png";